"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFooter = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
exports.StyledFooter = function (_a) {
    var _b;
    var sections = _a.sections;
    return (react_1.default.createElement("div", { className: "footer" },
        react_1.default.createElement("div", { className: "footer-section" }, (_b = sections.option) === null || _b === void 0 ? void 0 : _b.map(function (el, index) { return (react_1.default.createElement(core_1.Button, __assign({ key: index, type: "submit", style: {
                minWidth: (sections === null || sections === void 0 ? void 0 : sections.option.length) > 2 ? '50px' : '126px',
                marginRight: index === 0 && !(sections === null || sections === void 0 ? void 0 : sections.isSingle) ? '18px' : null,
            }, variant: "contained", color: "primary" }, el === null || el === void 0 ? void 0 : el.props, { className: ((sections === null || sections === void 0 ? void 0 : sections.isSingle) ? 'single' : '') + " footer-btn" }), el.name)); }))));
};
//# sourceMappingURL=StyledFooter.js.map